import { createRouter } from "@/helpers/routerHelper";

import Messwerte from "./views/Messwerte.vue";
import Station from "./views/Station.vue";
import Ganglinie from "./views/Ganglinie.vue";
import Messung from "./views/Messung.vue";
import Download from "./views/Download.vue";

export default createRouter("/gus", [
  {
    path: "/:id",
    redirect: "/:id/messwerte"
  },
  {
    path: "/:id/messwerte",
    name: "messwerte",
    component: Messwerte,
    props: true
  },
  {
    path: "/:id/station",
    name: "station",
    component: Station,
    props: true
  },
  {
    path: "/:id/ganglinie",
    name: "ganglinie",
    component: Ganglinie,
    props: true
  },
  {
    path: "/:id/messung",
    name: "messung",
    component: Messung,
    props: true
  },
  {
    path: "/:id/download",
    name: "download",
    component: Download,
    props: true
  }
]);
